import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { finalize, map, Observable, of, tap } from 'rxjs';
import { VendorService } from '../services/vendor-service';
import { RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { EmployeeService } from '../services/employee-service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-loan-requests',
 standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    RouterModule,
    MatDialogModule,
    MatSpinner,
    MatPaginatorModule,
    MatTooltipModule
  ],
  templateUrl: './loan-requests.component.html',
  styleUrl: './loan-requests.component.css'
})
export class LoanRequestsComponent {
  constructor(private employeeService: EmployeeService, private dialog: MatDialog) { }
  displayedColumns: string[] = [
    'slno',
    'no',
    'id',
    'employee_name',
    'employee_no',
    'reason',
    'request_date',
    'payment_date',
    'loan_amount',
    'first_installment_amount',
    'guarantor',
    'approval_status'    
  ];
  isLoading = false;
  loanRequests$!: Observable<any[]>;
  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.getLoanRequestStatus();
  }

  getLoanRequestStatus() {
    this.isLoading = true;
    this.loanRequests$ = this.employeeService.getLoanRequestStatus().pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }
}
